(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sections-related"] && !Shopify.designMode) return;
  try {
    const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;

		observer.unobserve(productRecommendationsSection);

		const url = productRecommendationsSection.dataset.url;

		fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-sections-related');

				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
				}
			})
			.catch((e) => {
				console.error(e);
			});
	};

	const productRecommendationsSection = document.querySelector(
		'.product-sections-related'
	);
	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin: '0px 0px 600px 0px',
	});

	observer.observe(productRecommendationsSection);
  } catch(e) { console.error(e); }
})();

})();
